import { useMutation } from "@tanstack/react-query";
import { uploadSessionAudio } from "../services/api";

interface UploadAudioParams {
  sessionId: string;
  audio: Blob;
  fileName?: string;
}

const useUploadAudio = () => {
  const mutation = useMutation({
    mutationKey: ["uploadAudio"],
    mutationFn: ({ sessionId, audio, fileName }: UploadAudioParams) =>
      uploadSessionAudio(sessionId, audio, fileName),
  });
  return {
    ...mutation,
    uploadAudio: mutation.mutate,
    uploadAudioAsync: mutation.mutateAsync,
  };
};

export default useUploadAudio;
